import {ref} from 'vue';

/**
 * @Author Ken
 * @CreateDate 2021-12-15 11:05
 * @desc 处理异步操作, 带loading
 * @params
 * @return
 */
export function useExecute(config = {}) {
  const loading = ref(!!config.value);

  if (typeof config.execute !== 'function') {
    throw 'useExecute: execute SHOULD be function';
  }

  async function execute(...params) {
    loading.value = true;
    let response;
    try {
      response = await config.execute(...params);
    } finally {
      loading.value = false;
    }
    return response;
  }

  return {
    loading,
    execute,
  };
}
